export default __webpack_public_path__ + "static/media/timeco2.9892e9b6.svg";